import { useLayoutEffect } from "react";


export default function WisprFlow() {
  useLayoutEffect(() => {
    window.location.replace("https://links.outskill.com/wisprflow");
  }, []);
  return null;
}
